import { createAction, props } from '@ngrx/store';
import {
  DocumentCreate,
  Folder,
  FolderCreate,
} from '@lockton-apps/shared/interfaces';

export enum FoldersActionTypes {
  AddFromDocumentDialog = '[Folders/Page] Add Folder From Document Dialog',
  AddFromDocumentDialogSuccess = '[Folders/API] Add Folder From Document Dialog Success',
  AddFromDocumentDialogFailure = '[Folders/API] Add Folder From Document Dialog Failure',
}

export const addFromDocumentDialog = createAction(
  FoldersActionTypes.AddFromDocumentDialog,
  props<{
    folder: FolderCreate;
    documents: Omit<DocumentCreate, 'folderId'>[];
  }>()
);

export const addFromDocumentDialogSuccess = createAction(
  FoldersActionTypes.AddFromDocumentDialogSuccess,
  props<{ folder: Folder; documents: Omit<DocumentCreate, 'folderId'>[] }>()
);

export const addFromDocumentDialogFailure = createAction(
  FoldersActionTypes.AddFromDocumentDialogSuccess,
  props<{ error: any }>()
);
